import React from 'react';
import './TextBlock.css';


const TextBlock = (props) => {
	return (

		<div className="text-wrapper">
			<h4>{ props.name }</h4>
{props.children}
		</div>

	);
}

export default TextBlock;


// WEBPACK FOOTER //
// ./src/Components/TextBlock.jsx